// font weight
const fontWeightBold = {
  fontWeight: 700,
};

const fontWeightSemiBold = {
  fontWeight: 600,
};

const fontWeightRegular = {
  fontWeight: 400,
};

const fontWeightLight = {
  fontWeight: 300,
};

// Heading
const h1Options = {
  fontSize: 48,
  lineHeight: "72px",
};

const h2Options = {
  fontSize: 38,
  lineHeight: "56px",
};

const h3Options = {
  fontSize: 32,
  lineHeight: "48px",
};

const h4Options = {
  fontSize: 28,
  lineHeight: "42px",
};

const h5Options = {
  fontSize: 24,
  lineHeight: "36px",
};

const h6Options = {
  fontSize: 20,
  lineHeight: "30px",
};

const h7Options = {
  fontSize: 16,
  lineHeight: "24px",
};

const h8Options = {
  fontSize: 14,
  lineHeight: "20px",
};

const fontFamilyHeading = {
  fontFamily: "Poppins",
};

// Body
const b1Options = {
  fontSize: 24,
  lineHeight: "36px",
};

const b2Options = {
  fontSize: 20,
  lineHeight: "30px",
};

const b3Options = {
  fontSize: 18,
  lineHeight: "26px",
};

const b4Options = {
  fontSize: 16,
  lineHeight: "24px",
};

const b5Options = {
  fontSize: 14,
  lineHeight: "20px",
};

const b6Options = {
  fontSize: 12,
  lineHeight: "18px",
};

const fontFamilyBody = {
  fontFamily: "Poppins",
};

export default {
  // Heading
  "&.heading-h1-bold": {
    ...h1Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h2-bold": {
    ...h2Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h3-bold": {
    ...h3Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h4-bold": {
    ...h4Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h5-bold": {
    ...h5Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h6-bold": {
    ...h6Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h7-bold": {
    ...h7Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h8-bold": {
    ...h8Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },

  // Body b1
  "&.body-b1-bold": {
    ...b1Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b1-regular": {
    ...b1Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b1-light": {
    ...b1Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },

  // Body b2
  "&.body-b2-bold": {
    ...b2Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b2-regular": {
    ...b2Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b2-light": {
    ...b2Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },

  // Body b3
  "&.body-b3-bold": {
    ...b3Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b3-regular": {
    ...b3Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b3-light": {
    ...b3Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },

  // Body b4
  "&.body-b4-bold": {
    ...b4Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b4-regular": {
    ...b4Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b4-light": {
    ...b4Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },

  // Body b5
  "&.body-b5-bold": {
    ...b5Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b5-regular": {
    ...b5Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b5-light": {
    ...b5Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },

  // Body b6
  "&.body-b6-bold": {
    ...b6Options,
    ...fontWeightSemiBold,
    ...fontFamilyBody,
  },
  "&.body-b6-regular": {
    ...b6Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
  "&.body-b6-light": {
    ...b6Options,
    ...fontWeightLight,
    ...fontFamilyBody,
  },
};
